import { Checkbox, ListItemText, Tooltip } from '@mui/material'
import Menu from '@mui/material/Menu'
import MenuItem from '@mui/material/MenuItem'
import { t } from 'i18next'
import React, { ReactElement, useState } from 'react'
import Icon from 'ui/atoms/Icon/Icon'
import styles from './NotificationFilterButton.module.less'

type NotificationFilterButtonProps = {
  tooltipTitle: string
  allFilters: string[]
  allFilterLabels: Record<string, string>
  handleFilterChange: (filter: string[]) => void
}

export default function NotificationFilterButton({
  tooltipTitle,
  allFilters,
  allFilterLabels,
  handleFilterChange,
}: NotificationFilterButtonProps): ReactElement {
  const [filterAnchorEl, setFilterAnchorEl] = useState<null | HTMLElement>(null)

  const [selectedFilters, setSelectedFilters] = useState<string[]>([])
  const filterMenuOpen = Boolean(filterAnchorEl)

  const handleShowAllFilters = () => {
    setSelectedFilters([])
    setFilterAnchorEl(null)
    handleFilterChange([])
  }

  const handleLocalFilterChange = (filter: string, singleSelect = false) => {
    setSelectedFilters((prev) => {
      if (singleSelect) {
        const newFilter = prev[0] === filter ? [] : [filter]
        handleFilterChange(newFilter)
        return newFilter
      } else {
        const newFilter = prev.includes(filter) ? prev.filter((f) => f !== filter) : [...prev, filter]
        handleFilterChange(newFilter)
        return newFilter
      }
    })
  }

  const handleFilterMenuClick = (event: React.MouseEvent<HTMLElement>) => {
    setFilterAnchorEl(event.currentTarget)
  }
  const handleFilterMenuClose = () => {
    setFilterAnchorEl(null)
  }
  return (
    <div>
      <Tooltip title={tooltipTitle} arrow placement="top">
        <span>
          <Icon
            icon={selectedFilters.length > 0 ? 'fas fa-filter' : 'far fa-filter'}
            size="large"
            onClick={handleFilterMenuClick}
          />
        </span>
      </Tooltip>
      <Menu anchorEl={filterAnchorEl} open={filterMenuOpen} onClose={handleFilterMenuClose}>
        <MenuItem
          onClick={handleShowAllFilters}
          dense
          className={styles.NotificationFilterButton_MenuItemContainer}
          sx={{
            '&.Mui-selected': {
              backgroundColor: 'transparent',
            },
          }}
        >
          <ListItemText primary={t('Reset filters')} />
        </MenuItem>
        {allFilters.map((filter) => (
          <MenuItem
            key={filter}
            selected={selectedFilters.includes(filter)}
            onClick={() => handleLocalFilterChange(filter)}
            dense
            className={styles.NotificationFilterButton_MenuItemContainer}
            sx={{
              '&.Mui-selected': {
                backgroundColor: 'transparent',
              },
            }}
          >
            <ListItemText primary={allFilterLabels[filter] || filter} />
            <Checkbox
              checked={selectedFilters.includes(filter)}
              tabIndex={-1}
              disableRipple
              className={styles.NotificationFilterButton_FilterCheckbox}
            />
          </MenuItem>
        ))}
      </Menu>
    </div>
  )
}
